export const LegislationKey = {
    REACH: 'reach',
    SCIP: 'scip',
    ROHS: 'rohs',
    FCM: 'fcm',
    PPWR: 'ppwr',
    CBAM: 'cbam',
    EU_CMR: 'eu_cmr',
};

export const RegulationType = {
    REGULATION: 'regulation',
    DIRECTIVE: 'directive',
    INDUSTRY_ORGANIZATION_REGULATION: 'industry_organization_regulation',
    COMPANY_REGULATION: 'company_regulation',
    CLIMATE_DIRECTIVE: 'climate_directive',

    translationKey(type) {
        return 'Component(RegulationTypeEnum):' + type;
    },

    all() {
        return [
            this.REGULATION,
            this.DIRECTIVE,
            this.INDUSTRY_ORGANIZATION_REGULATION,
            this.COMPANY_REGULATION,
            this.CLIMATE_DIRECTIVE,
        ];
    }
};

export function makeProductStatusTranslationKey(status) {
    return 'ProductLegislationStatus:' + status;
}

export function makeProductEventTranslationKey(event) {
    return 'ProductLegislationEvent:' + event;
}

export const LegislationProductStatus = {
    NEW: 'new',
    NOT_APPLICABLE: 'n_a',
    APPLICABLE: 'applicable',
    INCOMPLETE: 'incomplete',
    EXEMPTED: 'exempted',
    DOES_NOT_INCLUDE_CONCERN_ELEMENTS: 'no_concern_elements', //  no svhc
    INCLUDES_CONCERN_ELEMENTS: 'includes_concern_elements', // svhc
    INCLUDES_CONCERN_ELEMENTS_INVESTIGATED: 'includes_concern_elements_investigated', // svhc +
    SUBSTANCES_OF_CONCERN: 'substances_of_concern',
    NO_SUBSTANCES_OF_CONCERN: 'no_substances_of_concern',
    ONGOING: 'ongoing',
    SENT_TO_SUPPLIER: 'sent_to_supplier', //  supplier
    REQUESTED: 'requested',
    SCIP_NOTIFIED: 'scip_notified',
    SCIP_NOTIFICATION_FAILED: 'scip_notification_failed',
    SCIP_NOTIFICATION_SUCCEEDED: 'scip_notification_succeeded',
    SCIP_REFERENCE: 'scip_ref',
    COMPLIANT: 'compliant',
    NOT_COMPLIANT: 'not_compliant',
};

export const InformationLevel = {
    CONCERN_SUBSTANCES: 'concern_substances',
    FULL_MATERIAL_DECLARATION: 'fmd'
};

export const legislationTranslationMixin = {
    methods: {
        makeProductStatusTranslationKey(status) {
            return 'ProductLegislationStatus:' + status;
        },
        makeProductEventTranslationKey(event) {
            return 'ProductLegislationEvent:' + event;
        }
    }
};
